import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_USERS } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import { SALES_PERSON } from '@/lib/constants/securityRoles'

const users = {
  namespaced: true,
  state: buildInitialState({
    userList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  actions: {
    getUsersWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getUsers', { ...rootGetters['userFilters/getSearchObject'] })
    },
    getUsers ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting users, please wait...' })

      return api.doGet({ path: PATH_USERS, parameters: filters })
        .then(json => json.data)
        .then(users => {
          commit('updateStatus', { status: COMPLETE })
          commit('setUsers', users)
          return users
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get users')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getUserOptions ({ dispatch }, filters = {}) {
      return api.doGet({ path: PATH_USERS, parameters: filters })
        .then(json => json.data || [])
        .catch(() => {
          notifyError(dispatch, 'Unable to load users')
          return []
        })
    },
    getUsersWithFiltersPaginated ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getUsersPaginated', {
        ...rootGetters['userFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getUsersPaginated: createPaginatedGetAction(PATH_USERS, 'setPaginatedUsers', 'Unable to get users'),
    getSaleUsers: ({ dispatch }) => {
      return dispatch('getUsers', { SecurityRoles: SALES_PERSON.name })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setUsers (state, users) {
      state.userList = users
      state.totalRecords = Array.isArray(users) ? users.length : 0
    },
    setPaginatedUsers (state, { result, totalRecords }) {
      state.userList = result
      state.totalRecords = totalRecords
    }
  }
}

export default users
